import { ContentChild, Directive, ElementRef, Inject, Input, Optional, Renderer2, TemplateRef } from '@angular/core';
import { SafeAny } from '@ngx-simple/core/types';
import { SIM_TABLE } from './default-options';

export interface CellDef {
  template: TemplateRef<SafeAny>;
}

@Directive({ selector: '[simCellDef]' })
export class SimCellDefDirective implements CellDef {
  constructor(public template: TemplateRef<SafeAny>) {}
}

@Directive({ selector: '[simHeaderCellDef]' })
export class SimHeaderCellDefDirective implements CellDef {
  constructor(public template: TemplateRef<SafeAny>) {}
}

@Directive({ selector: '[simFooterCellDef]' })
export class SimFooterCellDefDirective implements CellDef {
  constructor(public template: TemplateRef<SafeAny>) {}
}

@Directive({
  selector: '[simColumnDef]',
  providers: [{ provide: 'SiM_SORT_HEADER_COLUMN_DEF', useExisting: SimColumnDefDirective }]
})
export class SimColumnDefDirective {
  @Input('simColumnDef') name: string;

  @Input() sticky: boolean;

  @Input() stickyEnd: boolean;

  @ContentChild(SimCellDefDirective) cell: SimCellDefDirective;

  @ContentChild(SimHeaderCellDefDirective)
  headerCell: SimHeaderCellDefDirective;

  @ContentChild(SimFooterCellDefDirective)
  footerCell: SimFooterCellDefDirective;

  constructor(@Inject(SIM_TABLE) @Optional() public _table?: SafeAny) {}
}

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: 'th[sim-header-cell]'
})
export class SimHeaderCellDirective {
  constructor(columnDef: SimColumnDefDirective, elementRef: ElementRef<HTMLTableHeaderCellElement>, renderer: Renderer2) {
    renderer.addClass(elementRef.nativeElement, 'sim-table-header-cell');
    renderer.setAttribute(elementRef.nativeElement, 'role', 'columnheader');
  }
}

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: 'td[sim-footer-cell]'
})
export class SimFooterCellDirective {
  constructor(columnDef: SimColumnDefDirective, elementRef: ElementRef<HTMLTableCellElement>, renderer: Renderer2) {
    renderer.addClass(elementRef.nativeElement, 'sim-table-footer-cell');
    renderer.setAttribute(elementRef.nativeElement, 'role', 'gridcell');
  }
}

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: 'td[sim-cell]'
})
export class SimCellDirective {
  constructor(columnDef: SimColumnDefDirective, elementRef: ElementRef<HTMLTableCellElement>, renderer: Renderer2) {
    renderer.addClass(elementRef.nativeElement, 'sim-table-cell');
    renderer.setAttribute(elementRef.nativeElement, 'role', 'gridcell');
  }
}
